"use client"

import CTA from "@/components/Category/CTA";
import ToFAQ from "@/components/Category/ToFAQ";
import { site } from "@/data/default";
import { ReactNode } from "react";

// Komponen kecil untuk menghindari duplikasi visual
const Card = ({ title, content }: { title: string; content: string }) => (
  <div className="bg-white shadow-md rounded-2xl p-6 border border-gray-200 hover:shadow-lg transition-all duration-200">
    <h4 className="font-semibold text-lg mb-2">{title}</h4>
    <p className="text-sm">{content}</p>
  </div>
);

export const soundSystemContents: ReactNode = (
  <>
    <h2 className="text-xl font-bold mb-2">Sewa Sound System Terdekat: Suara Bening, Setting Cepat, Harga Bersahabat</h2>
    <div className="mb-4 text-base leading-relaxed">
      Di dunia acara, suara adalah napas. Satu kesalahan kecil pada sound system, dan seluruh momen bisa kehilangan ruh-nya. Inilah kenapa <strong>sewa sound system terdekat</strong> bukan sekadar pilihan tapi keputusan cerdas. Tanpa beli
      alat mahal², tanpa ribet urus teknis, semua langsung tersedia. Profesional, praktis, dan performa taktis.
    </div>
    <div className="grid md:grid-cols-2 gap-4 mb-6">
      <Card
        title="Ready 24 Jam di Area Terdekat"
        content="Kamu butuh speaker aktif, mixer digital, mic wireless atau alat band dalam hitungan jam? Semua langsung bisa dikirim ke lokasi. Sewa sound system terdekat² tanpa nunggu, tanpa drama."
      />
      <Card
        title="Paket Lengkap Speaker, Mixer, Alat Band"
        content="Gak cuma speaker dan kabel. Kami sediakan juga drum set, ampli, sound card, hingga lighting basic. Cocok untuk pensi, konser kecil, wedding, open mic, dan launching produk."
      />
      <Card title="Gratis Setup & Instalasi Area Terdekat" content="Teknisi kami langsung handle semua: setting, balancing, sampai uji soundcheck. Gak ada feedback, gak ada delay. Suara keluar optimal sejak detik pertama." />
      <Card
        title="Spek Profesional dari Brand Kelas Dunia"
        content="Kami pakai perangkat dari JBL, Yamaha, Behringer, hingga Shure. Hasil? Suara vocal bening, instrumen tight, dan noise minimal. Dipakai event skala mall hingga panggung komunitas."
      />
      <Card
        title="Harga Sewa Sound System Terdekat yang Masuk Akal"
        content="Mulai dari Rp300rb-an, kamu udah bisa dapet setup basic. Butuh full set? Ada. Paket bulanan juga tersedia untuk cafe, hotel, atau event reguler. Semua harga fleksibel tergantung kebutuhan kamu."
      />
    </div>
    <div className="text-base leading-relaxed mb-6">
      <strong>Sewa sound system terdekat</strong> bikin kamu gak perlu repot cari vendor jauh². Kami hadir di titik strategis kota siap antar setup ke rumah, gedung, bahkan area outdoor. Cocok buat kamu yang cari suara berkualitas tapi tetap hemat waktu & tenaga.
    </div>
    <h2 className="text-xl font-bold mb-3">Full Support Selama Acara</h2>
    <p className="mb-4">Tim teknisi akan standby sepanjang acara. Gangguan teknis? Langsung tangani di tempat. Kamu tinggal nikmati panggung, tanpa perlu mikirin kabel kusut atau mic mati tiba².</p>
    <h2 className="text-xl font-bold mb-3">Indoor? Outdoor? Gasss</h2>
    <p className="mb-4">Dari seminar di ballroom hotel, hingga konser di lapangan terbuka semua bisa kami tangani. Tinggal sebut kebutuhan: watt, jumlah speaker, jenis mic kami bawa semuanya ke tempatmu.</p>
    <h2 className="text-xl font-bold mb-3">Booking Fleksibel, Bisa Mendadak</h2>
    <p className="mb-4">
      Acara mepet? Bisa! Kami siap kirim dan install di hari yang sama. Selama unit tersedia, <strong>sewa sound system terdekat</strong> tetap bisa kamu andalkan untuk kebutuhan mendesak tanpa kompromi kualitas.
    </p>

    <CTA
      title="Siap Buat Suara Acaramu Bersuara Bosku?"
      description="Klik tombol di bawah untuk booking sekarang. Cukup kirim lokasi & tanggal, kami yang urus sisanya."
      buttonText="Booking Sound System Sekarang"
      onClick={() => {
        window.open(
          `https://wa.me/${site.whatsapp}?text=Halo%2C%20saya%20ingin%20booking%20sound%20system.%20Lokasi%20dan%20tanggal%20sudah%20siap.`,
          "_blank"
        );
      }}
    />

    <ToFAQ
      category="Sound System"
    />


  </>
);